import styled from 'styled-components';

const StyledHeroConfig = styled.div`
    position: relative;
    display: block;
    z-index: 1;
    width: 50%;
    max-width: 650px;
    margin: 0 auto;
    border: none;
    height: calc(100vh - 93px);
    max-height: calc(100vh - 93px);
    display: flex;
    align-items: center;
    justify-content: center;
    @media screen and (max-width: 1023px){
      width: 100%;
      height: calc(70vh);
      max-height: calc(70vh);
    }
    canvas {
      width: 100%;
      height: 100%;
    }
    .iframe-wrap {
      position: relative;
      width: 100%;
      aspect-ratio: 16 / 9;
      iframe {
        position: relative;
        width: 100%;
        border: none;
        height: 100%;
        @media screen and (max-width: 1023px){
          position: relative;
          width: 100%;
          height: 300px;
        }
      }
    }
    .viewer-row{
        position: absolute;
        bottom: 40px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 24px;
        @media screen and (max-width: 1023px){
          bottom: 0;
          margin-bottom: 0;
        }
        img {
          flex: 0 0 40%;
          max-width: 100px;
          margin-right: 20px;
        }
        .color-mod {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          margin-right: 10px;
          cursor: pointer;
          span {
            width: 36px;
            height: 36px;
            border-radius: 50%;
            margin: 3px auto 0;
            display: block;
          }
          &.color-light {
            span {
              background-color: #834539;
            }
          }
          &.color-brown{
            span {
              background-color: #503e2d;
            }
          }
          &.color-black{
            span {
              background-color: #000;
            }
          }
          &.selected {
            border: 1px solid #426d74;
          }
        }
      }
`;


export {
  StyledHeroConfig
}